angular.module('impactx.input').component('ixClassificationInput', {
    bindings: {
        data: '=',
        name: '@',
        label: '@',
        form: '=',
        required: '=',
        readonly: '=',
        onSelect: '&?',
        entryPoint: '@',
        selectOnFocus: '=?',
        minLength: '@?',
        onValueChange: '&?',
        additionalDataArray: '=?'
    },
    controller: 'ClassificationInputCtrl',
    templateUrl: 'shared/input/templates/classification-input.tmpl.html',
});